import { compact } from 'lodash';

import { Co2Emission } from '@/lib/models/emissions/types';
import { sumTotalCo2Emissions } from '@/lib/models/emissions/utils/count-emissions';
import { ItineraryLegModel } from '@/lib/models/itinerary/types';

export const getItineraryTotalEmissions = (legs: ItineraryLegModel[]): Co2Emission => {
  const legEmissions = compact(legs.map((leg) => leg.emissions));
  return sumTotalCo2Emissions(legEmissions);
};
